import { COLORS } from '@/styles/colorTheme';
import { Container, Wrapper } from './PrimaryTapStyles';
import { useRef, useEffect, useState } from 'react';

interface PrimaryTapProps {
  children?: any;
  isActive?: boolean;
  color?: string;
  maxWidth?: any;
  margin?: any;
  onClick?: (event: any) => void;
  sx?: any;
}

const PrimaryTap = ({
  children,
  isActive = false,
  color = COLORS.Text400,
  maxWidth,
  margin = '0px',
  onClick,
  sx,
}: PrimaryTapProps) => {
  const refEL = useRef<HTMLDivElement>(null);
  const [isHover, setIsHover] = useState(false);

  useEffect(() => {
    const instance = refEL.current;

    instance.addEventListener('mouseover', () => {
      setIsHover(true);
    });

    instance.addEventListener('mouseleave', () => {
      setIsHover(false);
    });

    return () => {
      instance.removeEventListener('mouseover', () => {
        setIsHover(true);
      });

      instance.removeEventListener('mouseleave', () => {
        setIsHover(false);
      });
    };
  }, []);

  return (
    <Container ref={refEL} isActive={isActive} style={{ ...sx }} onClick={onClick} margin={margin}>
      <Wrapper maxWidth={maxWidth}>
        <div className={`text-md ${isActive || isHover ? 'text-primary-500' : color}`}>
          {children}
        </div>
      </Wrapper>
    </Container>
  );
};

export default PrimaryTap;
